export default __webpack_public_path__ + "static/media/392.efe0a759.jpg";